"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _listtable_data = require("./listtable_data");

var _definitionhelpers = require("../../../utils/definitionhelpers");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- LIST TABLE : DEFINITION --------------- ++++++++++ */


var _default = {
  name: 'ListTable',
  group: _definitionhelpers.groupNames.tables,
  props: {
    name: {
      type: 'string',
      default: 'table'
    },
    type: {
      type: 'string',
      default: 'fixed-column',
      options: ['fixed-column', 'standard']
    },
    variant: {
      type: 'string',
      default: 'standard',
      options: ['standard', 'slim', 'nowrap']
    },
    size: {
      type: 'string',
      default: 'full',
      options: ['full', 'auto']
    },
    paginationLocation: {
      type: 'string',
      default: 'bottom',
      options: ['bottom', 'bottom-left', 'top']
    },
    data: {
      type: 'array',
      default: _listtable_data.listtableData
    },
    columnHeads: {
      type: 'object',
      default: _listtable_data.listtableColumnHeads
    },
    exportData: {
      type: 'object',
      default: {
        fileName: 'test_export_current',
        excludedColumns: ['embed_uuid', '']
      }
    },
    exportAll: {
      type: 'object',
      default: {
        apiCall: function apiCall(e) {
          return alert('we have no api');
        },
        paramString: '',
        fileName: 'test export',
        excludedColumns: [],
        transpiler: function transpiler(e) {
          return console.log(e);
        }
      }
    },
    rowsPerPage: {
      type: 'number',
      default: 1
    },
    fixedColWidth: {
      type: 'number',
      default: 100
    },
    loading: {
      type: 'boolean',
      default: false,
      options: [false, true]
    },
    moreDetails: {
      type: 'boolean',
      default: false,
      options: [false, true]
    }
  }
};
exports.default = _default;